export enum ProcessStateNames {
    EditEvaluationPhase = 'EditEvaluationPhase',
    SubmissionDecisionPhase = 'SubmissionDecisionPhase',
    ReviewDocumentationDecisionPhase = 'ReviewDocumentationDecisionPhase',
    ReviewExternalDecisionPhase = 'ReviewExternalDecisionPhase',
    FinishedWithoutSubmission = 'FinishedWithoutSubmission',
    ReviewSubmissionDecisionPhase = 'ReviewSubmissionDecisionPhase',
    EditReportDataPhase = 'EditReportDataPhase',
    ReviewReportDataPhase = 'ReviewReportDataPhase',
    SubmissionPhase = 'SubmissionPhase',
    ManualSubmissionPendingPhase = 'ManualSubmissionPendingPhase',
    WaitingForFeedbackPhase = 'WaitingForFeedbackPhase',
    ErrorFeedback = 'ErrorFeedback',
    SuccessfullyFinished = 'SuccessfullyFinished',
    FinishedExternalReporting = 'FinishedExternalReporting',
}
